import { Vehicles, Funds } from "../libs/staticData";

const loadState = () => {
  try {
    let serializedState = localStorage.getItem("invest.fairtree.com");

    if (serializedState === null) {
      return initializeState();
    }

    const newState = JSON.parse(serializedState);

    if (newState.investVehicle?.value?.vehicles) {
      newState.investVehicle.value.vehicles = [...Vehicles];
    }

    if (newState.investVehicle?.value?.funds) {
      newState.investVehicle.value.funds = [...Funds];
    }

    return newState;
  } catch (err) {
    return initializeState();
  }
};

const saveState = (state) => {
  try {
    let serializedState = JSON.stringify(state);
    localStorage.setItem("invest.fairtree.com", serializedState);
  } catch (err) {}
};

const initializeState = () => {
  return {};
};

export const StateLoader = {
  loadState,
  saveState,
  initializeState,
};
